// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Workflows__container___i4QrI {
    margin: 8px;
    line-height: 1;
}

.Workflows__addIcon___IL38g {
    padding: 5px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Workflows__container___i4QrI`,
	"addIcon": `Workflows__addIcon___IL38g`
};
module.exports = ___CSS_LOADER_EXPORT___;
